/* Sahara Agate — product card (Ghar Soaps style): variant select, add to cart, buy now, hover image cycle */
if (!window.gsCardScripts) {
  window.gsCardScripts = true;

  /* ---------- helpers ---------- */
  const gsUpdateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count], .cart-count, #cart-count, .pm-icon-badge[data-cart-badge]').forEach(el => { el.textContent = count; });
  };

  const gsRefreshDrawer = async () => {
    try {
      const res = await fetch(window.location.pathname + '?sections=offcanvas-cart');
      const sections = await res.json();
      if (sections['offcanvas-cart']) {
        const doc = new DOMParser().parseFromString(sections['offcanvas-cart'], 'text/html');
        const fresh = doc.querySelector('cart-container');
        const current = document.querySelector('#offcanvas-cart cart-container');
        if (fresh && current) current.replaceWith(fresh);
        window.dispatchEvent(new CustomEvent('kt.cart.reloaded'));
      }
    } catch (e) { console.warn('Cart drawer refresh failed', e); }
  };

  const gsAdd = async (variantId, qty = 1) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    });
    if (!response.ok) {
      let msg = 'Could not add to cart';
      try { msg = (await response.json()).description || msg; } catch (e) {}
      throw new Error(msg);
    }
    return response.json();
  };

  /* ---------- wishlist ---------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.js-wishlist-toggle');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const handle = btn.dataset.productHandle;
    const list = JSON.parse(localStorage.getItem('shopify-wishlist') || '[]');
    const i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); btn.classList.remove('is-active'); }
    else {
      list.push(handle); btn.classList.add('is-active');
      setTimeout(() => {
        const d = document.getElementById('offcanvas-wishlist');
        if (d && window.bootstrap) bootstrap.Offcanvas.getOrCreateInstance(d).show();
      }, 300);
    }
    localStorage.setItem('shopify-wishlist', JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = list.length; el.style.display = list.length ? 'block' : 'none'; });
  });

  /* ---------- variant select → price + buttons ---------- */
  document.addEventListener('change', function (e) {
    const select = e.target.closest('[data-gs-variant-select]');
    if (!select) return;
    const card = select.closest('.gs-card');
    const opt = select.options[select.selectedIndex];
    if (!card || !opt) return;
    const current = card.querySelector('[data-gs-current]');
    const compare = card.querySelector('[data-gs-compare]');
    const off = card.querySelector('[data-gs-off]');
    if (current) current.textContent = opt.dataset.price || '';
    if (compare) { compare.textContent = opt.dataset.compare || ''; compare.hidden = !opt.dataset.compare; }
    if (off) { off.textContent = '(' + opt.dataset.off + '% OFF)'; off.hidden = !(Number(opt.dataset.off) > 0); }
    const available = opt.dataset.available === 'true';
    card.querySelectorAll('.js-quick-atc, .js-quick-buy').forEach(btn => {
      btn.dataset.variantId = opt.value;
      btn.disabled = !available;
      if (btn.classList.contains('js-quick-atc')) btn.textContent = available ? 'Add to Cart' : 'Sold Out';
    });
  });

  /* ---------- Add to cart ---------- */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-quick-atc');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    const originalText = btn.textContent;
    btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…';
    try {
      await gsAdd(btn.dataset.variantId, 1);
      btn.textContent = 'Added ✓';
      const cart = await (await fetch('/cart.js')).json();
      gsUpdateCartCount(cart.item_count);
      await gsRefreshDrawer();
      const drawer = document.getElementById('offcanvas-cart');
      if (drawer && window.bootstrap) bootstrap.Offcanvas.getOrCreateInstance(drawer).show();
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    } catch (err) {
      console.error(err); btn.textContent = 'Try again';
    }
    setTimeout(() => { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = originalText; }, 1600);
  });

  /* ---------- Buy now → add + go to checkout ---------- */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-quick-buy');
    if (!btn || btn.disabled) return;
    e.preventDefault(); e.stopPropagation();
    const originalText = btn.textContent;
    btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Please wait…';
    try {
      await gsAdd(btn.dataset.variantId, 1);
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err); btn.textContent = 'Try again';
      setTimeout(() => { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = originalText; }, 1600);
    }
  });

  /* ---------- Hover: scroll through all images ---------- */
  const gsSetActive = (media, index) => {
    const imgs = media.querySelectorAll('.gs-card__img');
    const dots = media.querySelectorAll('.gs-card__dot');
    imgs.forEach((img, i) => img.classList.toggle('is-active', i === index));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  };
  const gsStartCycle = (media) => {
    const imgs = media.querySelectorAll('.gs-card__img');
    if (imgs.length < 2 || media._gsTimer) return;
    let i = 0;
    media._gsTimer = setInterval(() => { i = (i + 1) % imgs.length; gsSetActive(media, i); }, 750);
  };
  const gsStopCycle = (media) => {
    if (media._gsTimer) { clearInterval(media._gsTimer); media._gsTimer = null; }
    gsSetActive(media, 0);
  };
  const gsMode = (media) => media.dataset.gsAutoscroll || 'hover';
  document.addEventListener('mouseover', (e) => {
    const media = e.target.closest('[data-gs-media]');
    if (media && gsMode(media) === 'hover' && !media.contains(e.relatedTarget)) gsStartCycle(media);
  });
  document.addEventListener('mouseout', (e) => {
    const media = e.target.closest('[data-gs-media]');
    if (media && gsMode(media) === 'hover' && !media.contains(e.relatedTarget)) gsStopCycle(media);
  });
  /* "Always" mode: start cycling on load and keep going */
  const gsInitAlways = () => {
    document.querySelectorAll('[data-gs-media][data-gs-autoscroll="always"]').forEach(gsStartCycle);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gsInitAlways);
  } else {
    gsInitAlways();
  }
  /* touch: swipe left/right on the image to change photo */
  let gsTouchX = null, gsTouchIdx = 0;
  document.addEventListener('touchstart', (e) => {
    const media = e.target.closest('[data-gs-media]');
    if (!media) return;
    gsTouchX = e.touches[0].clientX;
    gsTouchIdx = [...media.querySelectorAll('.gs-card__img')].findIndex(i => i.classList.contains('is-active'));
  }, { passive: true });
  document.addEventListener('touchend', (e) => {
    const media = e.target.closest('[data-gs-media]');
    if (!media || gsTouchX === null) return;
    const dx = e.changedTouches[0].clientX - gsTouchX; gsTouchX = null;
    const n = media.querySelectorAll('.gs-card__img').length;
    if (n < 2 || Math.abs(dx) < 30) return;
    e.preventDefault();
    gsTouchIdx = dx < 0 ? (gsTouchIdx + 1) % n : (gsTouchIdx - 1 + n) % n;
    gsSetActive(media, gsTouchIdx);
  });
}
